import { motion, AnimatePresence } from "framer-motion";
import { Heart } from "lucide-react";
import { CategoryBadge } from "./CategoryBadge";

// Full-screen one-at-a-time match reveal experience.
export const MatchReveal = ({ item, index, total, onNext, onClose }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key={item.id}
      className="reveal-overlay"
      data-testid="match-reveal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="reveal-glow" />
      <motion.div
        className="reveal-card"
        initial={{ scale: 0.9, opacity: 0, filter: "blur(12px)" }}
        animate={{ scale: 1, opacity: 1, filter: "blur(0px)" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <motion.div
          className="reveal-heart"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.25, type: "spring", stiffness: 260, damping: 14 }}
        >
          <Heart size={44} strokeWidth={1.5} />
        </motion.div>
        <motion.p
          className="reveal-title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          C'est un match ✨
        </motion.p>
        <div className="reveal-cat">
          <CategoryBadge category={item.question.category} />
        </div>
        <motion.p
          className="reveal-question"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.55 }}
        >
          {item.question.text}
        </motion.p>

        <div className="reveal-actions">
          <span className="reveal-counter">
            {index + 1} / {total}
          </span>
          {index + 1 < total ? (
            <button className="btn-primary" data-testid="reveal-next-btn" onClick={onNext}>
              Suivant
            </button>
          ) : (
            <button className="btn-primary" data-testid="reveal-done-btn" onClick={onClose}>
              Terminer
            </button>
          )}
        </div>
      </motion.div>
    </motion.div>
  </AnimatePresence>
);

export default MatchReveal;
